import { Autocomplete, InputAdornment, Paper, Stack, TextField, Button } from '@mui/material'
import "./ActivityNotesFilter.css";
import SearchIcon from "@mui/icons-material/Search";
import AddIcon from "@mui/icons-material/Add";
import { useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { setSelectedNotetitle } from '../../../../features/activityNotesSlice';
import { useEffect, useState } from 'react';
import BusinessActivityNotesFilter from './BusinessActivityNotesFilter';
import { selectUserData } from '../../../../features/userSlice';
import { CheckPermissions } from '../../../../logic/Admin/Permissions/CheckPermission/CheckPermissions';
import AddNewNote from '../ActivityNotesModals/AddNewNote';

const BusinessActivityNotesFilterCard = () => {
  const dispatch = useDispatch();
  const userData = useSelector(selectUserData)
  const [searchParams, setSearchParams] = useSearchParams();
  const filteredActivityNotes = useSelector((state: any) => state.activityNotes.filteredActivityNotes);
  const selectedNotetitle = useSelector((state: any) => state.activityNotes.selectedNotetitle);
  const [, setIsThisAdd] = useState(false);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const hasCreateActivityNotesPermission = CheckPermissions(
    userData?.data?.products?.assets,
    "overview",
    "create_activity_notes"
  );

  useEffect(() => {
    // Update selectedNotetitle when searchParams change
    dispatch(setSelectedNotetitle(searchParams.get("search")));
    // eslint-disable-next-line
  }, []);

  const handleAddClick = (_note: string) => {
    setIsThisAdd(true);
    setIsDialogOpen(true);
    setSearchParams((prevParams) => {
      const updatedParams = new URLSearchParams(prevParams);
      updatedParams.set("create", "true");
      return updatedParams;
    });
  }

  const handleCloseDialog = () => {
    setIsDialogOpen(false);
    setIsThisAdd(false);
    dispatch(setSelectedNotetitle(null)); // Clear selected note title when dialog closes
     setSearchParams((prevParams) => {
      const updatedParams = new URLSearchParams(prevParams);
      updatedParams.delete("create"); // Remove "create=true"
      updatedParams.delete("edit");
      updatedParams.delete("shareuid"); // Remove "edit=true"
      return updatedParams;
    });
  }

  const clearSelectedNotetitle = () => {
    dispatch(setSelectedNotetitle(null));
  };

  return (
    <>
      <Paper sx={{ padding: "0px", marginTop: "8px", boxShadow: "none" }}>
        <Stack flexDirection={"row"} justifyContent={"start"} gap={2} sx={{ paddingTop: "16px", paddingBottom: "16px" }}>
          <Autocomplete
            data-tracker="136"
            sx={{ width: "600px" }}
            options={filteredActivityNotes?.map((item: any) => item?.note) || []}
            value={selectedNotetitle} // Set value to selected note title
            onChange={(_, newValue) => {
              dispatch(setSelectedNotetitle(newValue));
              // Preserve existing search params while updating 'selectedNotetitle'
              setSearchParams((prevParams) => {
                const updatedParams = Object.fromEntries(prevParams); // Preserve previous params
                if (newValue) {
                  updatedParams.search = newValue; // Set new value
                } else {
                  delete updatedParams.search; // Remove from URL if cleared
                }
                return updatedParams;
              });
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Note Title"
                InputProps={{
                  ...params.InputProps,
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon sx={{ marginLeft: "12px" }} />
                    </InputAdornment>
                  ),
                }}
                color="secondary"
              />
            )}
            size="small"
          />
          <Stack flexDirection={"row"} justifyContent={"space-between"} sx={{ width: "100%" }}>
            <BusinessActivityNotesFilter clearSelectedNotetitle={clearSelectedNotetitle} />
            <Stack flexDirection={"row"} gap={2}>
              {hasCreateActivityNotesPermission ? (
                <Button
                  variant="contained"
                  color="secondary"
                  endIcon={<AddIcon />}
                  onClick={() => handleAddClick("")}
                  data-tracker="106"
                >
                  WRITE A NEW NOTE
                </Button>
              ) : (
                <Button
                  variant="contained"
                  color="secondary"
                  endIcon={<AddIcon />}
                  disabled
                >
                  {" "}
                  WRITE A NEW NOTE
                </Button>
              )}
            </Stack>
          </Stack>
        </Stack>
      </Paper>
      <AddNewNote open={isDialogOpen} handleClose={handleCloseDialog} />
    </>
  )
}

export default BusinessActivityNotesFilterCard
